import { getBrands } from '../../services/api/brand.api';
import { GET_BRAND_LIST_REQUEST, GET_BRAND_LIST_SUCCESS, GET_BRAND_LIST_FAILURE } from '../types';
import { transformBrands } from '../../transforms/brand';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformBrands([]),
		pagination: transformPagination({}),
	},

	getters: {
		brandOptions: (state) => {
			const brand = {
				name: 'All brands',
				value: null,
			};

			const brands = state.data.map((item) => {
				return {
					name: item.name,
					value: item.id,
				};
			});

			return [brand, ...brands];
		},
	},

	mutations: {
		[GET_BRAND_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_BRAND_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			state.data = transformBrands(data);
			state.pagination = transformPagination(meta);
		},
		[GET_BRAND_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getBrands({ commit }) {
			try {
				const params = {
					per_page: 100000,
				};
				commit(GET_BRAND_LIST_REQUEST);
				const { data } = await getBrands(params);
				commit(GET_BRAND_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_BRAND_LIST_FAILURE, error);
			}
		},
	},
};